import { useRouteParams as useRouteParamsBase } from '../../_hooks/useRouteParams';

interface RouteParams {
  clientId: string;
  redirectTo?: 'profile' | 'comprehensive' | 'assetBucketing';
}

export const useRouteParams = () => {
  return useRouteParamsBase<RouteParams>();
};
